import type {ReactNode} from 'react';
import {observer} from 'mobx-react';
import {ConfigProvider} from 'antd';
import ruRu from 'antd/locale/ru_RU';
import {ToastContainer} from 'react-toastify';
import {useEffect} from 'react';
import ThemeStore from '../theme.store';
import {getAntdTheme} from '../styles/antdTheme';

type AppThemeProviderProps = {
    children: ReactNode;
};

const AppThemeProvider = observer(({children}: AppThemeProviderProps) => {
    useEffect(() => {
        ThemeStore.init();
        return () => ThemeStore.dispose();
    }, []);

    return (
        <ConfigProvider locale={ruRu} theme={getAntdTheme(ThemeStore.isDark)}>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme={ThemeStore.isDark ? 'dark' : 'light'}
            />
            {children}
        </ConfigProvider>
    );
});

export default AppThemeProvider;
